import React from 'react';
import classNames from 'classnames/bind';
import styles from './FormCancel.module.scss';
import { Row, Form } from 'antd';
import { SVGS } from '~/assets/assetsPath';

const cx = classNames.bind(styles);

const CancelModal = ({ onAgreeCancel, onRejectCancel, text }) => {
    return (
        <Form>
            <Form.Item>
                <Row justify="center" className={cx('name_page')}>
                    Confirm
                </Row>
            </Form.Item>
            <Form.Item>
                <Row justify="center" className={cx('bio')}>
                    {text}
                </Row>
            </Form.Item>
            {/* <Form.Item>
                <Row justify="center">
                    <img src={SVGS.IconNotiCancel} alt="" />
                </Row>
            </Form.Item> */}
            <Form.Item style={{ marginTop: '40px' }}>
                <Row>
                    <div className={cx('btn_cancel')} onClick={onRejectCancel}>
                        Cancel
                    </div>
                    <div className={cx('btn_logout')} onClick={onAgreeCancel}>
                        Agree
                    </div>
                </Row>
            </Form.Item>
        </Form>
    );
};

export default CancelModal;
